module.exports = __webpack_public_path__ + "static/media/icon-search.ef9083a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-search.svg
// module id = 1850
// module chunks = 0